/* eslint-disable complexity */
import { BookWidgetRefundableFareField } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';
import { LoginDashboardFieldsConfig } from '../../models/login-dashboard.interfaces';
import { stringToBoolean } from '../utils/utils.adapter';

export const prepareRefundableFareField = (
  retrieveSearchData: RetrieveSearchData | null,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig,
  loginDashboardFieldsConfig: LoginDashboardFieldsConfig | null,
  hasDeepLinkingParams: boolean
): BookWidgetRefundableFareField => {
  if (bookWidgetFieldsMasterConfig.refundableFareField?.hide) {
    return {
      checked: false,
      disable: false,
      hide: true
    };
  }

  let checked = false;
  if (loginDashboardFieldsConfig?.bookOnlyRefundable) {
    checked = true;
  } else if (
    !hasDeepLinkingParams &&
    !bookWidgetFieldsMasterConfig?.refundableFareField?.disable &&
    stringToBoolean(retrieveSearchData?.refundableFlightsOnly)
  ) {
    checked = true;
  }

  return {
    checked,
    disable: bookWidgetFieldsMasterConfig.refundableFareField?.disable || false,
    hide: bookWidgetFieldsMasterConfig.refundableFareField?.hide || false
  };
};
